import { z } from "zod";

export const NotificationSubscriptionCountSchema = z
  .number()
  .transform((value) => value || 0);

export type NotificationSubscriptionCountType = z.infer<
  typeof NotificationSubscriptionCountSchema
>;
